import { useNuxtData, useRoute, useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { PRODUCT as ROUTE_NAMES } from '../../route-names'

export function useMasterPPScale(route = useRoute()) {
  const experiments = useExperiments()
  const { market } = useMarketplace()
  const { FF_ENABLE_COUNTRIES_MASTER_PP_SCALE = '' } = useRuntimeConfig().public
  const { data } = useNuxtData(`MasterPP-${route.params.slug}`)

  const masterPPScaleProductId = computed(() => data.value?.productId)
  const masterPPScaleGrade = computed(() => data.value?.grade)
  const masterPPScaleSpecialOfferType = computed(
    () => data.value?.specialOfferType,
  )

  const isMasterPPScaleUrl = computed(
    () => route.name === ROUTE_NAMES.MASTER_PP,
  )

  const isMasterPPScaleExperimentActive = computed(
    () => experiments['experiment.masterPP'] === 'withMasterPP',
  )

  const isMasterPPScaleFeatureEnabled = computed(() =>
    FF_ENABLE_COUNTRIES_MASTER_PP_SCALE.includes(market.countryCode),
  )

  return {
    masterPPScaleProductId,
    masterPPScaleGrade,
    masterPPScaleSpecialOfferType,
    isMasterPPScaleUrl,
    isMasterPPScaleExperimentActive,
    isMasterPPScaleFeatureEnabled,
  }
}
